/**
 * @title The add another dialog
 * @description The dialog shown when the user adds an item in the search/category dialog - will ask the user to add another, or continue
 * @image https://storageaccountourimbea2.blob.core.windows.net/tradein2guide/mainpage-addanother.png
 */
import * as React from "react";
import {FC} from "react";
import {Box, Dialog, DialogActions, DialogContent, Slide} from "@mui/material";
import {makeStyles} from "@mui/styles";
import {useRecoilValue} from "recoil";
import {AddItemButton, StyledTypography} from "../../../../providers/layout/LayoutProvider";
import {LocalizationsAtom} from "../../../../providers/localization/LocalizationProvider";
import {TransitionProps} from "@mui/material/transitions";
import clsx from "clsx";

const Transition = React.forwardRef(function Transition(
   props: TransitionProps & {
      children: React.ReactElement;
   },
   ref: React.Ref<unknown>,
) {
   return <Slide direction="up" ref={ref} {...props} />;
});

type AddAnotherDialogProps = {
   open: boolean;
   onHide: (noThanks: boolean) => void;
   onAddAnother: (e: any) => void;
}

export const AddAnotherDialog: FC<AddAnotherDialogProps> = ({open, onHide, onAddAnother,}) => {
   const localizations = useRecoilValue(LocalizationsAtom);
   const classes = useAddAnotherDialogStyles();

   const handleAddAnother = (e: any) => {
      onAddAnother(e);
      onHide(false);
   };

   return (
      <Dialog
         open={open}
         TransitionComponent={Transition}
         onClose={() => onHide(false)}
         maxWidth="sm"
         fullWidth
         className={clsx(classes.dialog, 'c2s-dialog')}
      >
         <DialogContent className={classes.dialogContent}>
            <StyledTypography variant="h2" type="main" className={classes.title}>
               {localizations.addAnotherItemTitle}
            </StyledTypography>
            <StyledTypography variant="body1" type="main" className={classes.subtitle}>
               {localizations.addAnotherItemPrompt}
            </StyledTypography>
         </DialogContent>
         <DialogActions className={classes.actions}>
            <Box className={classes.buttonContainer}>
               <AddItemButton isEmpty={true}
                              disabled={false}
                              onClick={handleAddAnother}>
                  {localizations.addAnotherItem}
               </AddItemButton>
               <AddItemButton isEmpty={false}
                              disabled={false}
                              sx={{marginLeft: '10px'}}
                              onClick={() => onHide(true)}>
                  {localizations.addAnotherItemNo}
               </AddItemButton>
            </Box>
         </DialogActions>
      </Dialog>
   );
};

const useAddAnotherDialogStyles = makeStyles({
   dialog: {
   },
   dialogContent: {
      padding: '30px 20px 10px 20px',
      textAlign: 'center'
   },
   title: {
      marginBottom: '15px'
   },
   subtitle: {
      marginBottom: '20px'
   },
   actions: {
      padding: '0px 20px 30px 20px'
   },
   buttonContainer: {
      width: '100%',
      display: 'flex',
      justifyContent: 'center'
   }
});
